// Pauses the reader makes that the text does not ask for.
// The implementation lives in src/shared/pauses.js (CommonJS), shared with the
// server-side task runner; this file only re-exports it for the browser.
import * as shared from '../shared/pauses';

export const {
  HOP_SEC, MIN_CUT_SEC, levelFrames, findPauses, pauseKind, planPauseCuts, cutsTotal, previewSegments,
} = shared;
